import Reveal from "@/components/feature/Reveal";
import { painPoints } from "@/mocks/home";

export default function PainPointsSection() {
  return (
    <section id="concerns" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <Reveal className="mb-12 text-center md:mb-16">
          <p className="font-label text-[36px] font-bold tracking-[0.15em] text-foreground-700 md:text-[40px]">
            PAIN POINTS
          </p>
          <h2 className="mt-3 font-heading text-4xl font-black leading-tight text-foreground-950 md:text-7xl">
            こんなお悩みはありませんか？
          </h2>
        </Reveal>

        <div className="space-y-16 md:space-y-24">
          {painPoints.map((point, index) => (
            <div
              key={point.no}
              className={`grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-16 ${
                index % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
            >
              <Reveal>
                <div className="flex h-64 w-full items-center justify-center overflow-hidden rounded-lg border border-background-200 bg-background-100 md:h-96">
                  <img
                    src={point.image}
                    alt={`${point.text}のイメージ`}
                    title={`ナンバ ${point.text}`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
              </Reveal>

              <Reveal delay={100}>
                <div className="flex items-center gap-4">
                  <span className="font-display text-5xl font-black leading-none text-background-300 md:text-6xl">
                    {point.no}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-xl font-black leading-snug text-foreground-950 md:text-3xl">
                  {point.text}
                </h3>
                <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600 md:text-base">
                  {point.description}
                </p>
              </Reveal>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-col items-center md:mt-20">
          <p className="text-center font-heading text-4xl font-black leading-tight text-foreground-950 md:text-7xl">
            株式会社ナンバが支援します。
          </p>
        </div>
      </div>
    </section>
  );
}